import type { OptionProps } from '@flos/react-ui/build/core/forms/select/select-input';
import { selector } from 'recoil';
import { insuranceCompaniesAtom } from '../atoms/insuranceCompaniesAtom';

export const selectableInsuranceCompaniesSelector = selector<OptionProps[]>({
    key: 'selectableInsuranceCompaniesSelector',
    get: ({ get }) => {
        const insuranceCompanies = get(insuranceCompaniesAtom);
        return insuranceCompanies
            ? (insuranceCompanies
                  .filter((company) => company.name !== undefined && company.code !== undefined)
                  .map((company) => ({
                      label: company.name,
                      value: company.code
                  })) as OptionProps[])
            : [];
    }
});
